import React, { Component } from "react";
import moment from "moment";
import Bridge from "../../utils/Bridge";
import { Spin, Collapse } from "antd";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import {RESEARCH_TYPE} from '../../utils/consts';

const items = [
  {
    key: "1",
    label: "What is the ECAS score?",
    children: (
      <p>
        The ECAS (Edinburgh Cognitive and Behavioral ALS Screen) is a
        comprehensive assessment tool designed to evaluate cognitive and
        behavioral function in individuals with ALS (amyotrophic lateral
        sclerosis). It helps healthcare providers track changes in cognition and
        behavior over time.
      </p>
    ),
  },
  {
    key: "2",
    label: "What does each section of the ECAS score evaluate?",
    children: (
      <p>
        The ECAS consists of several sections that assess different aspects of
        cognitive and behavioral function, including: Cognitive Function: This
        includes tests for memory, language, attention, and executive function
        (e.g., problem-solving, planning).Behavioral Symptoms: This section
        evaluates emotional and behavioral changes such as apathy,
        disinhibition, and other mood or personality changes commonly associated
        with ALS.
      </p>
    ),
  },
  {
    key: "3",
    label: "My scores differ from session to session, what does this mean?",
    children: (
      <p>
        Variations in your ECAS scores from session to session can occur for
        several reasons, such as differences in mood, fatigue, attention, or
        even the time of day the assessment is administered. It’s important to
        remember that the ECAS score is a snapshot of cognitive and behavioral
        function at a specific point in time, and small fluctuations are not
        uncommon. If you have concerns about significant changes in your scores,
        it’s best to discuss them with your neurologist for a more detailed
        evaluation.
      </p>
    ),
  },
];

export default class ECAS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ecas_form_a_list: [],
      ecas_form_b_list: [],
      ecas_form_c_list: [],
      loading: false,
    };
  }
  componentDidMount() {
    this.get_ecas_form_list();
  }
  get_ecas_form_list = () => {
    this.setState({ loading: true });
    let params =
      "?participants_id=" + localStorage.getItem("ap_id")+'&research_type='+RESEARCH_TYPE;
    Bridge.ecas
      .get(params)
      .then((res) => {
        if (res.status == "1") {
          // form a
          let ecas_form_a_list = [];
          for (let item of res.data.ecas_form_a_list) {
            let new_date=item.submitted_date.split(',')[0]
            let date = moment(new_date, "Do MMM YYYY").format("MM/DD/YYYY");            
            item.form_submission_date=date
            item.total =
              Number(item.written_picture_score) +
              Number(item.spelling_score) +
              Number(item.language_comprehension_score) +
              Number(item.reverse_digit_span_score) +
              Number(item.executive_alternation_score) +
              Number(item.sentence_completion_score) +
              Number(item.social_congnition_score) +
              Number(item.fluency_ls_score) +
              Number(item.fluency_lt_score) +
              Number(item.dot_countring_score) +
              Number(item.cube_countring_score) +
              Number(item.number_location_score) +
              Number(item.recall_score) +
              Number(item.delayed_recall_score) +
              Number(item.delayed_congniation_total_score);
              ecas_form_a_list.push(item);
          }
          // form b
          let ecas_form_b_list = [];
          for (let item of res.data.ecas_form_b_list) {
            let new_date=item.submitted_date.split(',')[0]
            let date = moment(new_date, "Do MMM YYYY").format("MM/DD/YYYY");            
            item.form_submission_date=date
            item.total =
              Number(item.written_picture_score) +
              Number(item.spelling_score) +
              Number(item.language_comprehension_score) +
              Number(item.reverse_digit_span_score) +
              Number(item.executive_alternation_score) +
              Number(item.sentence_completion_score) +
              Number(item.social_congnition_score) +
              Number(item.fluency_ls_score) +
              Number(item.fluency_lt_score) +
              Number(item.dot_countring_score) +
              Number(item.cube_countring_score) +
              Number(item.number_location_score) +
              Number(item.recall_score) +
              Number(item.delayed_recall_score) +
              Number(item.delayed_congniation_total_score);
              ecas_form_b_list.push(item);
          }
          // form c
          let ecas_form_c_list = [];
          for (let item of res.data.ecas_form_c_list) {
            let new_date=item.submitted_date.split(',')[0]
            let date = moment(new_date, "Do MMM YYYY").format("MM/DD/YYYY");            
            item.form_submission_date=date
            item.total =
              Number(item.written_picture_score) +
              Number(item.spelling_score) +
              Number(item.language_comprehension_score) +
              Number(item.reverse_digit_span_score) +
              Number(item.executive_alternation_score) +
              Number(item.sentence_completion_score) +
              Number(item.social_congnition_score) +
              Number(item.fluency_ls_score) +
              Number(item.fluency_lt_score) +
              Number(item.dot_countring_score) +
              Number(item.cube_countring_score) +
              Number(item.number_location_score) +
              Number(item.recall_score) +
              Number(item.delayed_recall_score) +
              Number(item.delayed_congniation_total_score);
              ecas_form_c_list.push(item);
          }
          this.setState({
            ecas_form_a_list: ecas_form_a_list,
            ecas_form_b_list: ecas_form_b_list,
            ecas_form_c_list: ecas_form_c_list,
          });
        }
        this.setState({ loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  };
  onChange = (key) => {
  };
  render() {
    return (
      <div
        className="als_frs_sessions"
        style={{ overflowY: "visible", maxHeight: "fit-content" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 px-0">
              <Spin spinning={this.state.loading}>
                <h5 className="pb-3">ECAS Form A</h5>
                <table style={{ overflowY: "scroll", maxHeight: 300 }}>
                  <tr>
                    <th>Date of Session </th>
                    <th>Total ECAS Score</th>
                    <th>Download ECAS Form</th>
                  </tr>
                  {this.state.ecas_form_a_list &&
                    this.state.ecas_form_a_list.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td style={{ width: 300 }}>
                            {item.form_submission_date ? item.form_submission_date : "---"}
                          </td>
                          <td>{item.total ? item.total : 0}</td>
                          <td>
                            <Link
                              to={
                                "/ecas-form-view-a?secret=" + item.ecas_forms_id
                              }
                              className="btn btn-primary"
                              style={{
                                background: "#d06338",
                                border: "1px solid #d06338",
                              }}
                            >
                              <FaEye
                                style={{ position: "relative", top: -2 }}
                              />{" "}
                              View
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  {this.state.ecas_form_a_list.length == 0 && (
                    <tr>
                      <td colSpan={3} style={{ textAlign: "center" }}>
                        Not available..
                      </td>
                    </tr>
                  )}
                </table>
                <br />
                <hr />
                <h5 className="pb-3">ECAS Form B</h5>
                <table style={{ overflowY: "scroll", maxHeight: 300 }}>
                  <tr>
                    <th>Date of Session </th>
                    <th>Total ECAS Score</th>
                    <th>Download ECAS Form</th>
                  </tr>
                  {this.state.ecas_form_b_list &&
                    this.state.ecas_form_b_list.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td style={{ width: 300 }}>
                            {item.form_submission_date ? item.form_submission_date : "---"}
                          </td>
                          <td>{item.total ? item.total : 0}</td>
                          <td>
                            <Link
                              to={
                                "/ecas-form-view-b?secret=" +
                                item.ecas_form_b_id
                              }
                              className="btn btn-primary"
                              style={{
                                background: "#d06338",
                                border: "1px solid #d06338",
                              }}
                            >
                              <FaEye
                                style={{ position: "relative", top: -2 }}
                              />{" "}
                              View
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  {this.state.ecas_form_b_list.length == 0 && (
                    <tr>
                      <td colSpan={3} style={{ textAlign: "center" }}>
                        Not available..
                      </td>
                    </tr>
                  )}
                </table>
                <br />
                <hr />
                <h5 className="pb-3">ECAS Form C</h5>
                <table style={{ overflowY: "scroll", maxHeight: 300 }}>
                  <tr>
                    <th>Date of Session </th>
                    <th>Total ECAS Score</th>
                    <th>Download ECAS Form</th>
                  </tr>
                  {this.state.ecas_form_c_list &&
                    this.state.ecas_form_c_list.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td style={{ width: 300 }}>
                            {item.form_submission_date ? item.form_submission_date : "---"}
                          </td>
                          <td>{item.total ? item.total : 0}</td>
                          <td>
                            <Link
                              to={
                                "/ecas-form-view-c?secret=" +
                                item.ecas_form_c_id
                              }
                              className="btn btn-primary"
                              style={{
                                background: "#d06338",
                                border: "1px solid #d06338",
                              }}
                            >
                              <FaEye
                                style={{ position: "relative", top: -2 }}
                              />{" "}
                              View
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  {this.state.ecas_form_c_list.length == 0 && (
                    <tr>
                      <td colSpan={3} style={{ textAlign: "center" }}>
                        Not available..
                      </td>
                    </tr>
                  )}
                </table>
                <br />
                <div>
                  <p style={{ fontSize: 16 }}>
                    <i>
                      *Please note that changes in your scores do not
                      automatically indicate a change in cognitive function. For
                      an accurate evaluation, we recommend consulting with your
                      neurologist. The purpose of sharing this data with you is
                      to support our commitment to transparency and open access.
                      By providing participants in EverythingALS studies with
                      access to their data, we aim to empower you with the
                      information needed for you to stay informed and involved
                      in your healthcare decisions.
                    </i>
                  </p>
                </div>
                <br />
                <h5 class="pt-2 pb-3">
                  Frequently Asked Questions: Understanding your Score
                </h5>
                <Collapse
                  items={items}
                  defaultActiveKey={["1"]}
                  onChange={this.onChange}
                />
              </Spin>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
